/* vp-tints-4.js -- per-flavour background tints for the Vegan Protein builder
   arm (claude-4).

   ONLY loaded by templates/product.vegan-protein-builder-russ-claude-4.json.

   WHAT THE ENGINE ALREADY DOES: vp-pdp-2.js paints a per-flavour gradient onto
   BOTH the chip thumbnail (.bag) and the hero photo (#vpStage), from one colour
   pair per flavour, and it re-paints #vpStage whenever the focused chip
   changes. So the "carry it through to the main photo" behaviour already
   exists -- the only thing wrong was the colour VALUES. Several flavours had no
   mapping and fell back to brand navy (#0d394e): Dole Whip Pineapple and all
   three IHOP flavours. Natural Vanilla was green. Correcting the pair fixes the
   chip and the hero together, because both read the same source.

   WHERE THE COLOURS COME FROM: sampled off the pouch artwork itself, by
   quantising each product image and taking the dominant saturated cluster.
   Share of sampled pixels in brackets.

     Pineapple   #F4A627  (63%)   IHOP x3   #54A4D6  (59%)
     Vanilla     #F7C556  (27%)   Oatmeal   #C98E6D  (12%)
     Brownie     #642C1A  (12%)

   STRAWBERRY IS THE ONE HAND-PICKED VALUE. Sampling returned amber (#F1A624,
   52%) because the Dole sunburst logo dominates that pouch. Amber is both wrong
   for the flavour and a near-duplicate of Pineapple's #F4A627, which would
   defeat the point of tinting at all -- so it uses the pink from the lower
   band of the pouch instead.

   TWO IMPLEMENTATION NOTES:

   1. IDEMPOTENCE. Writing style.background then reading it back gives the
      browser's SERIALISED form (#F4A627 comes back as "rgb(244, 166, 39)"), so
      a naive string compare never matches, we would rewrite every pass, that
      rewrite trips the MutationObserver, and it loops forever. The check tests
      whether the serialised style already mentions the colour in EITHER form.
      If the engine has repainted it navy, ours is absent and we re-apply; if
      ours is already there, we do nothing.

   2. SYNCHRONOUS. Applied straight from the observer callback rather than a
      debounced timeout. MutationObserver callbacks are microtasks and drain
      before paint; a setTimeout is a macrotask and lets a frame through, which
      shows as a flash of the engine's navy before the correct tint lands. */
(function () {
  "use strict";

  /* First match wins, so IHOP sits above the fruit patterns -- "IHOP Double
     Blueberry Pancakes" must not fall through to a berry rule. */
  var TINTS = [
    { match: /ihop/i,                     c1: "#54A4D6", c2: "#8FC8E6" },
    { match: /pineapple/i,                c1: "#F4A627", c2: "#F8C55E" },
    { match: /strawberry/i,               c1: "#E8437A", c2: "#F291B4" },
    { match: /vanilla/i,                  c1: "#F7C556", c2: "#FAE3AE" },
    { match: /brown\s*sugar|oatmeal/i,    c1: "#C98E6D", c2: "#E3B694" },
    { match: /brownie|chocolate/i,        c1: "#642C1A", c2: "#96604A" }
  ];

  /* Same geometry and opacities the engine uses, so a corrected flavour sits
     at exactly the same weight as an untouched one. */
  function grad(t) {
    return "linear-gradient(168deg,color-mix(in srgb," + t.c1 +
           " 34%,transparent),color-mix(in srgb," + t.c2 + " 14%,transparent))";
  }

  function tintFor(name) {
    var hit = null;
    TINTS.forEach(function (t) { if (!hit && t.match.test(name)) hit = t; });
    return hit;
  }

  function rgbOf(hex) {
    var n = parseInt(hex.slice(1), 16);
    return "rgb(" + ((n >> 16) & 255) + ", " + ((n >> 8) & 255) + ", " + (n & 255) + ")";
  }

  /* See note 1 above: accept either the authored hex or the serialised rgb(). */
  function alreadyApplied(el, hex) {
    var s = el.getAttribute("style") || "";
    return s.toLowerCase().indexOf(hex.toLowerCase()) !== -1 ||
           s.indexOf(rgbOf(hex)) !== -1;
  }

  function paint(el, t) {
    if (!el || !t) return;
    if (alreadyApplied(el, t.c1)) return;
    el.style.background = grad(t);
  }

  function tints() {
    var host = document.getElementById("vpChips");
    if (host) {
      [].slice.call(host.querySelectorAll(".vp-chip")).forEach(function (chip) {
        var nm = chip.querySelector(".nm");
        paint(chip.querySelector(".bag"), tintFor((nm && nm.textContent) || ""));
      });
    }
    /* The hero follows the focused flavour. #vpBag's alt is the flavour name
       ("Dole Whip(R) Pineapple, 15 servings"), which is also what the engine
       and vp-copy-4.js key the hero badge off. */
    var stage = document.getElementById("vpStage");
    if (stage) {
      var img = stage.querySelector("#vpBag");
      paint(stage, tintFor((img && img.getAttribute("alt")) || ""));
    }
  }

  function safeTints() { try { tints(); } catch (e) { /* never break the buy box */ } }

  var obs = new MutationObserver(function () { safeTints(); });

  function watch() {
    ["vpChips", "vpStage"].forEach(function (id) {
      var n = document.getElementById(id);
      if (n) obs.observe(n, { childList: true, subtree: true, attributes: true,
                              attributeFilter: ["style", "alt", "class"] });
    });
  }

  function start() { safeTints(); watch(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  window.addEventListener("load", safeTints);
})();